<template>
  <div class="ad-info-center-core">
    <div v-if="adRecordsLoading && !detailLayout" class="ad-loading-state"></div>
    <template v-if="!adRecordsLoading || detailLayout">
      <div v-if="detailContext" class="AdPageBody ad-detail-mode-body">
        <AdOverallRejectPanel
          v-if="showAdminOverallRejectPanel"
          ref="overallRejectPanel"
          v-model="overallRejectReasonDraft"
          :actor="approvalRejectBy"
          :templates="overallRejectTemplates"
          :force-active="rejectedApprovalCount > 0 || !!overallRejectReasonDraft"
          :rejected-count="rejectedApprovalCount"
        />
        <AdRecordGroupPanel
          :group="detailContext.group"
          :tab="detailContext.tab"
          :detail-layout="detailLayout"
        >
          <template v-if="detailLayout" #detail-header>
            <slot name="detail-header" />
          </template>
        </AdRecordGroupPanel>
      </div>
      <div v-else class="p-4 text-center text-muted">—</div>
    </template>
    <slot
      v-if="!detailLayout"
      name="footer"
      :haveAd="!!detailContext"
      :save="btnSave_Click"
      :submit="btnSubmit_Click"
    />
  </div>
</template>
<script>

import { AlertDialog } from "@/_helpers/AlertDialog";
import AdRecordGroupPanel from "./AdRecordGroupPanel.vue";
import AdOverallRejectPanel from "./AdOverallRejectPanel.vue";
import Privew from "./Privew.vue";
import adEffectiveDateComponentNews from "./adEffectiveDateComponentNews.vue";
import adDisplayPageComponentNews from "./adDisplayPageComponentNews.vue";
import mediaUploader from "../../components/form/upload/imgUploader/mediaUploader.vue";
import { getInitImageDataObj } from "@/_helpers/media-uploader-utils.js";
import { productService } from "@/_services/product.service";
import { adService, CompanyInfoService, adminService } from "../../_services";
import { LogService } from "../../_services/log.Service";
import {
  isProductApprovalResultRadioSelected,
  resolveProductApprovalResultCodeForSave,
} from "@/pages/NewproductInfoCenter/productApprovalFieldMeta";
import { resolveApprovalRejectByActor } from "@/_helpers/approvalActor";
import {
  PAGE_TYPE_ORDER,
  PAGE_TYPE_I18N,
  buildAdInfoCenterTLabel,
  resolveAdInfoCenterTrackingRoleId,
  getSubTypeMeta,
  getPageTypeLayout,
  resolveDisplayPreviewUrl,
} from "./adDisplayConfig";

const defaultUploadResult = {
  isSuccessful: true,
  message: "",
  failedItems: [],
};

export default {
  name: 'AdInfoCenterCore',
  mixins: [AlertDialog],
  components: {
    Privew,
    adEffectiveDateComponentNews,
    adDisplayPageComponentNews,
    mediaUploader,
    AdRecordGroupPanel,
    AdOverallRejectPanel,
  },
  props: {
    companyId: { type: [String, Number], required: true },
    fromAdmin: { type: Boolean, default: false },
    detailAdDetailId: { type: [String, Number], required: true },
    detailAdPackageId: { type: [String, Number], default: null },
    detailPcAdDetailId: { type: [String, Number], default: null },
    detailPcAdPackageId: { type: [String, Number], default: null },
    detailMobileAdDetailId: { type: [String, Number], default: null },
    detailMobileAdPackageId: { type: [String, Number], default: null },
    detailPageType: { type: String, default: null },
    detailLayout: { type: Boolean, default: false },
    detailAdminDisplayStatusHint: { type: String, default: null },
  },
  data() {
    return {
      prodCats: [],
      cdnURL: "https://cdn.adsalecdn.com/EMP/Backend/",
      HotAppIds: [],
      AdsDisplayOption: {
        Cat: [],
        App: [],
        Keyword_Options: []
      },
      TabList: [],
      adRecordInfos: [],
      adBySearchRecords: [],
      adDetailLocationRecords: [],
      detailAdminDisplayStatus: null,
      detailIsLaunch: 0,
      approvalContentResults: [],
      approvalContentResultDrafts: {},
      /** 驳回操作人展示：优先详情 RejectByName，否则当前登录人 */
      approvalRejectBy: '',
      savingApprovalContentResultId: null,
      overallRejectReasonDraft: '',
      overallRejectTemplates: [],
      /** Cache key for overallRejectTemplates: approvalId, or 0 when loaded via GetRejectReasons fallback */
      overallRejectTemplatesApprovalId: null,
      fieldRejectErrorByKey: {},
      adRecordsLoading: false,
      uploadedFiles: {},
      dbUpdateCommands: {},
      pendingUploadFiles: {},
      imageBtnFiles: {},
      uploadResult: { ...defaultUploadResult },
      dirty: false,
      initSettling: true,
      IsCreated: true,
      CheckVals: false,
      SubmitStrus: true,
      SelectCustomErrorStrus: false,
      HasErrorData: [],
      CompanyInfoPhoto: "https://cdn.adsalecdn.com/EMP/AdvertismentInfoCenter/logoAd_default1.png?version=20250909_1635&resize,h_64,limit_1",
      AllAdOptionsData: {},
    };
  },
  watch: {
    companyId(val, oldVal) {
      if (val === oldVal || val == null || val === '') return;
      this.reload();
    },
    detailAdDetailId(val, oldVal) {
      if (val == null || val === '' || val === oldVal) return;
      this.reload();
    },
    detailContext: {
      immediate: true,
      handler(val) {
        if (this.detailLayout) {
          this.$emit("core-ready", !!val);
        }
      },
    },
    adBySearchRecords: {
      handler() {
        this.markDirty();
      },
      deep: true,
    },
    adRecordsLoading: {
      immediate: true,
      handler(val) {
        if (this.detailLayout) {
          this.$emit("detail-loading", val);
        }
      },
    },
  },
  computed: {
    GetPowerStrus() {
      if (!this.detailLayout) return false;
      const primaryAd = this.detailContext?.group?.primaryAd;
      if (!primaryAd) return false;
      return adService.resolveAdRowStatus(primaryAd) === 'expired';
    },
    currentTabType() {
      return this.detailContext?.tab?.type;
    },
    langid() {
      return localStorage.getItem("currentLangId");
    },
    companyid() {
      return this.companyId;
    },
    trackingRoleId() {
      return resolveAdInfoCenterTrackingRoleId(this.$store);
    },
    imgDialogUrl() {
      return 'https://cdn.adsalecdn.com/EMP/Backend/Images/Ad/';
    },
    detailContext() {
      const targetIds = new Set(
        [this.detailAdDetailId, this.detailPcAdDetailId, this.detailMobileAdDetailId]
          .map((id) => Number(id))
          .filter((id) => id > 0)
      );
      if (!targetIds.size) return null;
      for (let i = 0; i < this.TabList.length; i++) {
        const tab = this.TabList[i];
        if (this.detailPageType && tab.type !== this.detailPageType) continue;
        for (const group of tab.displayGroups || []) {
          const records = [group.primaryAd, group.pcAd, group.mobileAd].filter(Boolean);
          if (records.some((r) => targetIds.has(Number(r.adDetailId)))) {
            return { tab, tabIndex: i, group };
          }
        }
      }
      return null;
    },
    /** 审批模式等价：管理员详情即审批上下文 */
    isApprovalMode() {
      return !!this.fromAdmin;
    },
    /**
     * 供应商 / 编辑驳回 UI：整单已驳回(R) 时显示。
     * 广告不受 SHOW_EDIT_SUPPLIER_REJECT_REASON 约束（默认开启）。
     */
    showAdRejectPanels() {
      const code = String(this.getCurrentApprovalStatusCode() || '').trim().toUpperCase();
      if (code === 'R') return true;
      const display = String(this.detailAdminDisplayStatus || '').trim();
      return display === 'rejected';
    },
    /** 管理员字段/总驳回：人工审批中、已审批、已驳回可查看；审批中(P/AI)不显示 */
    showAdminAdRejectPanels() {
      if (!this.fromAdmin) return false;
      const code = String(this.getCurrentApprovalStatusCode() || '').trim().toUpperCase();
      if (['PA', 'R', 'A'].includes(code)) return true;
      const display = String(this.detailAdminDisplayStatus || '').trim();
      return ['pendingManualAudit', 'rejected', 'live', 'pendingGoLive'].includes(display);
    },
    showAdminOverallRejectPanel() {
      if (!this.fromAdmin || !this.detailLayout) return false;
      const code = String(this.getCurrentApprovalStatusCode() || '').trim().toUpperCase();
      if (code === 'PA' || code === 'R' || code === 'A') return true;
      const display = String(this.detailAdminDisplayStatus || '').trim();
      return display === 'pendingManualAudit'
        || display === 'rejected'
        || display === 'live'
        || display === 'pendingGoLive';
    },
    rejectedApprovalCount() {
      return (this.approvalContentResults || []).filter((row) =>
        isProductApprovalResultRadioSelected(row.resultCode)
      ).length;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    adInfoCenterTLabel(location, action, subType = '', adDetailId = null) {
      const actionKey = subType ? `${subType}_${action}` : action;
      return buildAdInfoCenterTLabel(location, actionKey, this.companyid, this.trackingRoleId, adDetailId);
    },
    SetHasErrorData() {
      this.HasErrorData = [];
      this.CheckVals = false;
    },
    todoSave() {
      return this.btnSave_Click();
    },
    refresh() {
      return this.reload();
    },
    async reload() {
      await this.LoadAdRecords();
    },
    getAdDetails() {
      if (!this.detailContext) return [];
      const group = this.detailContext.group;
      // 与 SubmitAdDetailGroup 一致：PC/Mobile 成对时 ApprovalHeader 只挂 PC，审批只传 PC
      if (group?.isPaired && (group.pcAd || group.primaryAd)) {
        return adService.dedupeAdRecordsForApproval([group.pcAd || group.primaryAd]);
      }
      return adService.dedupeAdRecordsForApproval(this.getGroupRecords(group));
    },
    async init() {
      this.loadCompanyLogo();
      this.GetAdsDisplayOption();
      this.GetProductCatList();
      this.GetSearchAdOptions();
      this.GetHotAdIds();
      await this.LoadAdRecords();
    },
    markDirty() {
      if (this.IsCreated || this.adRecordsLoading || this.initSettling) return;
      this.dirty = true;
      this.$store.state.dirty = true;
    },
    onProductSelected(ad, val) {
      this.$set(ad, '_selectedProduct', val);
      this.markDirty();
    },
    clearDirty() {
      this.dirty = false;
      this.$store.state.dirty = false;
    },
    emitDetailMetaIfNeeded() {
      if (!this.detailLayout) return;
      const meta = adService.buildDetailMetaFromRecords(
        this.adRecordInfos,
        {
          adDetailId: this.detailAdDetailId,
          pcAdDetailId: this.detailPcAdDetailId,
          mobileAdDetailId: this.detailMobileAdDetailId,
          pageType: this.detailPageType,
        },
        this.fromAdmin
      );
      if (meta && this.fromAdmin) {
        meta.adminDisplayStatus = this.detailAdminDisplayStatus
          || this.detailAdminDisplayStatusHint
          || meta.adminDisplayStatus
          || null;
      }
      if (meta) {
        meta.isLaunch = this.detailIsLaunch;
      }
      this.$emit("detail-meta-loaded", meta);
    },
    async RefreshCompantedFunc() {
      // 先拉取最新选项，再递增 refreshToken 通知子组件刷新（与旧版 default 一致，不重新 LoadAdRecords）
      await Promise.all([
        this.GetSearchAdOptions(),
        this.GetProductCatList(),
        this.GetHotAdIds(),
      ]);
      this.GetAdsDisplayOption();
      const tabIndex = this.detailContext?.tabIndex;
      if (tabIndex != null && this.TabList[tabIndex]) {
        this.TabList[tabIndex].refreshToken = (this.TabList[tabIndex].refreshToken || 0) + 1;
      }
    },
    getUploadStateKey(adOrId) {
      const adDetailId = typeof adOrId === "object" ? adOrId?.adDetailId : adOrId;
      return adDetailId ? `upload_${adDetailId}` : "";
    },
    getUploadUsageType(ad) {
      // usageType 来自 V_adPackagePageType（后端返回）；不在前端写死 adPackageId -> usageType 映射
      return String(ad?.usageType ?? ad?.UsageType ?? "").trim();
    },
    getAdMediaDeviceType(ad) {
      return adService.getAdMediaDeviceType(ad);
    },
    resetUploadState() {
      this.uploadedFiles = {};
      this.dbUpdateCommands = {};
      this.pendingUploadFiles = {};
      this.imageBtnFiles = {};
      this.uploadResult = { ...defaultUploadResult };
    },
    initializeUploadState() {
      this.adRecordInfos.forEach((ad) => {
        if (!ad?.isUpload) return;
        const stateKey = this.getUploadStateKey(ad);
        if (!stateKey) return;
        const usageType = this.getUploadUsageType(ad);
        const src = this.normalizeAdMediaUrl(adService.resolveAdMediaPath(ad));
        // 优先用 Approval UsageId（MediaFile.RID）作为媒体 id
        const imgRows = this.getApprovalContentResults(ad);
        const usageId = imgRows.find((r) => r.usageId != null && String(r.usageId).trim() !== '')?.usageId;
        const mediaId = usageId != null ? usageId : `${usageType || stateKey}-${ad.adDetailId}`;
        const initialFiles = src
          ? [getInitImageDataObj(
            {
              imageId: ad.adDetailId,
              cdnLnk: src,
            },
            {
              id: mediaId,
              cdnLink: src,
              orderId: 1,
              usageType,
            }
          )]
          : [];
        this.$set(this.uploadedFiles, stateKey, initialFiles);
        this.$set(this.dbUpdateCommands, stateKey, []);
        this.$set(this.pendingUploadFiles, stateKey, []);
        this.$set(this.imageBtnFiles, stateKey, []);
      });
    },
    refreshUploadMediaBindings() {
      // media-uploader 对 MediaArray 的 watch 非 immediate：加载后换新引用，确保初始图能灌进组件
      Object.keys(this.uploadedFiles || {}).forEach((stateKey) => {
        const files = this.uploadedFiles[stateKey];
        if (!Array.isArray(files) || files.length === 0) return;
        this.$set(this.uploadedFiles, stateKey, files.map((item) => ({ ...item })));
      });
    },
    async LoadAdRecords() {
      this.adRecordsLoading = true;
      this.IsCreated = true;
      this.initSettling = true;
      this.clearDirty();
      try {
        const res = await adService.GetAdRecordDetail(this.companyId, this.langid, {
          adDetailId: this.detailAdDetailId,
          adPackageId: this.detailAdPackageId,
          pcAdDetailId: this.detailPcAdDetailId,
          pcAdPackageId: this.detailPcAdPackageId,
          mobileAdDetailId: this.detailMobileAdDetailId,
          mobileAdPackageId: this.detailMobileAdPackageId,
          pageType: this.detailPageType,
          includeExpired: !!this.detailLayout,
        });
        if (res.isSuccessful) {
          this.resetUploadState();
          this.detailAdminDisplayStatus = res.data?.adminDisplayStatus || null;
          this.detailIsLaunch = Number(res.data?.isLaunch ?? res.data?.IsLaunch ?? 0) === 1 ? 1 : 0;
          this.adRecordInfos = adService.sortAdRecordsByLastSubmitDate(res.data.adRecordInfos || []);
          this.adBySearchRecords = res.data.adBySearchRecords || [];
          this.adDetailLocationRecords = res.data.adDetailLocationRecords || [];
          this.approvalContentResults = adService.mapApprovalContentResults(res.data.approvalContentResults);
          this.approvalContentResultDrafts = {};
          this.fieldRejectErrorByKey = {};
          this.overallRejectReasonDraft = '';
          this.overallRejectTemplates = [];
          this.overallRejectTemplatesApprovalId = null;
          this.approvalContentResults.forEach((row) => {
            this.$set(this.approvalContentResultDrafts, row.approvalRequestResultId, row.rejectReason || '');
            row._savedResultCode = String(row.resultCode ?? '');
          });
          this.prepareRecordViewModels();
          this.initializeUploadState();
          this.GenerateAdTypeTabs();
          if (this.fromAdmin) {
            this.loadOverallRejectTemplates();
          }
          try {
            this.hydrateApprovalRejectBy(this.adRecordInfos);
            this.hydrateOverallRejectReasonFromRecords();
          } catch (e) {
            console.error('hydrate ad reject actor/reason failed', e);
          }
          this.ChangeHasErrorData();
          this.$nextTick(() => {
            this.refreshUploadMediaBindings();
          });
          this.emitDetailMetaIfNeeded();
        } else if (res && !res.isSuccessful) {
          console.error('GetAdRecordDetail failed', res.systemErrorMsg || res);
          this.adRecordInfos = [];
          this.TabList = [];
        }
      } finally {
        this.adRecordsLoading = false;
        setTimeout(() => {
          this.IsCreated = false;
          this.clearDirty();
          setTimeout(() => {
            this.initSettling = false;
          }, 1200);
        }, 800);
      }
    },
    prepareRecordViewModels() {
      this.adRecordInfos.forEach((ad) => {
        if (!ad._selectedProduct) {
          this.$set(ad, "_selectedProduct", null);
        }
      });
    },
    GenerateAdTypeTabs() {
      const grouped = adService.groupAdRecordsByPageType(this.adRecordInfos);
      let pageTypes = Object.keys(grouped);
      pageTypes.sort((a, b) => {
        const ai = PAGE_TYPE_ORDER.indexOf(a);
        const bi = PAGE_TYPE_ORDER.indexOf(b);
        return (ai < 0 ? 999 : ai) - (bi < 0 ? 999 : bi);
      });
      const prevMap = {};
      this.TabList.forEach((t) => { prevMap[t.type] = t; });

      this.TabList = pageTypes.map((type) => {
        const records = grouped[type];
        const prev = prevMap[type] || {};
        const tab = {
          type,
          name: this.$t(PAGE_TYPE_I18N[type] || type),
          status: prev.status ?? 0,
          t_label: buildAdInfoCenterTLabel(
            'CategoryTab',
            type,
            this.companyid,
            this.trackingRoleId
          ),
          IsShow: prev.IsShow ?? true,
          ApprovalInfo: {},
          AdCount: records.length,
          bannerApproval: prev.bannerApproval || this.resolveTabBannerApproval(records),
          refreshToken: prev.refreshToken || 0,
          records,
          displayGroups: adService.groupAdRecordsIntoDisplayGroups(records),
          formIds: adService.collectFormIdsFromRecords(records) || records[0]?.formIds || "",
        };
        this.syncTabApprovalInfoForTab(tab);
        return tab;
      });
    },
    resolveTabBannerApproval(records) {
      if (!records?.length) return "";
      const priority = records.find((r) => r.statusCode === "R")
        || records.find((r) => r.statusCode === "PA")
        || records.find((r) => r.statusCode === "P")
        || records.find((r) => r.statusCode === "A");
      return priority?.statusCode || "";
    },
    syncTabApprovalInfoForTab(tab) {
      const records = tab.records || [];
      const rejected = records.find((r) => r.statusCode === "R");
      const approvalInfo = adService.AdRecordsToApprovalInfo(records);
      tab.ApprovalInfo = {
        haveAd: records.length > 0,
        lastSaveDate: adService.AdRecordsToLastSaveDate(records),
        lastSubmitDate: adService.AdRecordsToLastSubmitDate(records),
        approvalDate: approvalInfo.approvalDate,
        rejectDate: rejected?.rejectDate || approvalInfo.rejectDate,
        rejectReason: rejected?.rejectReason || approvalInfo.rejectReason,
        statusCode: tab.bannerApproval || approvalInfo.statusCode,
      };
    },
    loadCompanyLogo() {
      CompanyInfoService.GetCompanyInfoAsync({ companyId: this.companyid }).then((res) => {
        if (!res.isSuccessful) return;
        const logo = res.data?.mediaFileList?.find(
          (item) => item.usageType.toLowerCase() === "companylogo"
        )?.fileName ?? "";
        if (logo) this.CompanyInfoPhoto = logo;
      });
    },
    onCompanyInfoMsg(data) {
      if (data?.Companylogo) {
        this.CompanyInfoPhoto = data.Companylogo;
      }
    },
    getPageCardRowStyle(pageType) {
      const { fullWidthCard } = getPageTypeLayout(pageType);
      if (this.detailLayout) {
        return { gap: '1rem', width: '100%' };
      }
      return fullWidthCard ? { gap: '1rem', width: '100%' } : { gap: '1rem' };
    },
    isFullWidthPageCard(pageType) {
      return getPageTypeLayout(pageType).fullWidthCard;
    },
    getPreviewWrapperStyle(pageType) {
      if (this.detailLayout) {
        const { fullWidthCard } = getPageTypeLayout(pageType);
        if (fullWidthCard) {
          return { flex: '1 1 auto', minWidth: '500px' };
        }
        return { flex: '1 1 0', minWidth: '0', width: '100%' };
      }
      return { flex: getPageTypeLayout(pageType).previewFlex };
    },
    needProductSelect(ad) {
      return !!(ad?.isSelectProduct ?? ad?.IsSelectProduct);
    },
    getRecordProductId(ad) {
      if (ad._selectedProduct?.id) return ad._selectedProduct.id;
      return adService.resolveAdProductId(ad) || 0;
    },
    getPagesTitle(ad) {
      const meta = getSubTypeMeta(ad.subType);
      const title = {
        Title: this.$t(meta.titleKey),
        Title_P: meta.titlePKey ? this.$t(meta.titlePKey) : "",
      };
      if (meta.hasTriggeringCondition) {
        title.TriggeringCondition = this.$t("lbl_EMPBE_Ad_Triggering_Condition");
        title.TriggeringCondition_P = this.$t("lbl_EMPBE_Ad_Triggering_Condition_P");
      }
      return title;
    },
    getLogoLocationIndex(ad) {
      const meta = getSubTypeMeta(ad.subType);
      return meta.logoLocationIndex ?? 0;
    },
    getPreviewPopupId(ad) {
      const meta = getSubTypeMeta(ad.subType);
      return `${meta.popupId}_${ad.adDetailId}`;
    },
    getPreviewDialogUrl(ad) {
      const meta = getSubTypeMeta(ad.subType);
      const file = meta.previewImageFile || meta.previewImage || meta.popupId;
      return `${this.imgDialogUrl}${file}_${this.langid}.png`;
    },
    getPreviewDialogTitle(ad) {
      const meta = getSubTypeMeta(ad.subType);
      const parts = meta.dialogTitleParts || [
        meta.section === 'emp' ? 'lbl_EMPBE_CPSeMarketplace' : 'lbl_EMPBE_ChinaPlasSite',
        meta.titleKey,
      ];
      return parts.map((key) => this.$t(key)).join('-');
    },
    getPreviewScrollToNums(ad) {
      return getSubTypeMeta(ad.subType).scrollToNums || 0;
    },
    toEffectiveDateData(ad) {
      return {
        haveAd: true,
        adDetailId: ad.adDetailId,
        effectiveDateFrom: ad.effectiveDateFrom,
        effectiveDateTo: ad.effectiveDateTo,
      };
    },
    getSearchRecords(adDetailId) {
      return this.adBySearchRecords.filter((x) => x.adDetailId === adDetailId);
    },
    getRecordLocations(ad) {
      return this.adDetailLocationRecords.filter(
        (x) => x.adPackageId === ad.adPackageId && x.adDetailId === ad.adDetailId
      );
    },
    getAdOptionsData(ad, pageType) {
      if (["starAd", "catListAd", "priorityAd", "videoAd"].includes(pageType)) {
        return this.AllAdOptionsData.adProdOptions;
      }
      return this.AllAdOptionsData.adCompOptions;
    },
    hasUploadEdit(adDetailId) {
      const stateKey = this.getUploadStateKey(adDetailId);
      return !!(
        stateKey
        && (
          (this.dbUpdateCommands[stateKey] && this.dbUpdateCommands[stateKey].length > 0)
          || (this.pendingUploadFiles[stateKey] && this.pendingUploadFiles[stateKey].length > 0)
          || (this.imageBtnFiles[stateKey] && this.imageBtnFiles[stateKey].length > 0)
        )
      );
    },
    normalizeAdMediaUrl(path) {
      if (!path) return '';
      const raw = String(path).trim();
      if (!raw) return '';
      if (raw.startsWith('data:') || raw.startsWith('blob:')) return raw;
      if (/^https?:\/\//i.test(raw)) return raw;
      if (raw.startsWith('//')) return `https:${raw}`;
      if (raw.startsWith('EMP/')) return `https://cdn.adsalecdn.com/${raw}`;
      const base = 'https://cdn.adsalecdn.com/EMP/Backend/';
      return base + raw.replace(/^\/+/, '');
    },
    needsFileUpload(url) {
      const raw = String(url || '').trim();
      if (!raw) return false;
      return raw.startsWith('data:') || raw.startsWith('blob:');
    },
    isPersistableCdnUrl(url) {
      if (!url || this.needsFileUpload(url)) return false;
      const normalized = this.normalizeAdMediaUrl(url);
      return /^https?:\/\//i.test(normalized);
    },
    getCurrentUploadCommands(ad) {
      return this.dbUpdateCommands[this.getUploadStateKey(ad)] || [];
    },
    getCurrentPendingUploadFiles(ad) {
      return this.pendingUploadFiles[this.getUploadStateKey(ad)] || [];
    },
    getCurrentImageBtns(ad) {
      return this.imageBtnFiles[this.getUploadStateKey(ad)] || [];
    },
    getCurrentUploadedFiles(ad) {
      return this.getUploadedFilesRef(ad);
    },
    /** 与旧 banner 一致：返回 uploadedFiles 稳定引用，供 MediaArray 绑定（勿每次 new []） */
    getUploadedFilesRef(ad) {
      const stateKey = this.getUploadStateKey(ad);
      if (!stateKey) return [];
      // initializeUploadState 已保证 key 存在；这里只读，保持引用稳定
      return this.uploadedFiles[stateKey] || [];
    },
    getCurrentUploadPreviewUrl(ad) {
      const imageBtns = this.getCurrentImageBtns(ad);
      if (imageBtns.length > 0) {
        return imageBtns[0].imgSrc || '';
      }
      if (this.getCurrentUploadCommands(ad).length > 0) {
        return '';
      }
      return this.getCurrentUploadedFiles(ad)[0]?.cdnLink || '';
    },
    getReuseCdnLnk(ad) {
      if (!this.hasUploadEdit(ad.adDetailId)) return '';
      if (this.getCurrentPendingUploadFiles(ad).length > 0) return '';
      const url = this.getCurrentUploadPreviewUrl(ad);
      return this.isPersistableCdnUrl(url) ? this.normalizeAdMediaUrl(url) : '';
    },
    getRecordImageSrc(ad) {
      const current = this.getCurrentUploadPreviewUrl(ad);
      if (this.hasUploadEdit(ad.adDetailId)) {
        return current;
      }
      return current || adService.resolveAdMediaPath(ad);
    },
    getPreviewProductId(ad) {
      if (ad._selectedProduct?.id) return ad._selectedProduct.id;
      return adService.resolveAdProductId(ad);
    },
    getUploadAspect(ad) {
      const meta = getSubTypeMeta(ad.subType);
      if (ad.pageType === "landingAd") return "0.89887:1";
      if (ad.pageType === "buttonAd") return "1.64948:1";
      return meta.aspectRatio || "7.7922:1";
    },
    getUploadGalleryStyle(ad) {
      const meta = getSubTypeMeta(ad.subType);
      if (ad.pageType === "landingAd") return "height: 178px; width: 160px;";
      if (ad.pageType === "buttonAd") return "height: 90px; width: 150px;";
      return meta.galleryStyle || "height: 70px; width: 536px;";
    },
    getMobileUploadAspect(ad) {
      const meta = getSubTypeMeta(ad.subType);
      return meta.mobileAspectRatio || "2.6667:1";
    },
    getMobileUploadGalleryStyle(ad) {
      const meta = getSubTypeMeta(ad.subType);
      return meta.mobileGalleryStyle || "height: 70px; width: 184px;";
    },
    isEmpMarketplaceBanner(ad) {
      return getSubTypeMeta(ad.subType).section === "emp";
    },
    getUploadMedia(ad) {
      // 兼容旧调用：与 getUploadedFilesRef 相同（MediaArray 应绑稳定引用）
      return this.getUploadedFilesRef(ad);
    },
    getApprovalContentResults(ad) {
      if (!ad?.adDetailId) return [];
      return adService.getApprovalContentResultsForAd(
        this.approvalContentResults,
        ad.adDetailId,
        null,
        'IMG'
      );
    },
    getDisplayPreviewUrl(ad) {
      return resolveDisplayPreviewUrl(ad, this.langid);
    },
    getApprovalContentResultsForSearchItem(item) {
      if (!item) return [];
      const adDetailId = item.adDetailId ?? null;
      const rid = item.rid ?? item.RID ?? null;
      if (!adDetailId || rid == null) return [];
      return adService.getApprovalContentResultsForAd(
        this.approvalContentResults,
        adDetailId,
        rid,
        'TEXT'
      );
    },
    /** 关键字等未传 status-code 时，从当前详情组 / tab 取审批状态（含 PA） */
    getCurrentApprovalStatusCode() {
      const detailTab = this.detailContext?.tab;
      const fromDetail = String(detailTab?.ApprovalInfo?.statusCode || detailTab?.bannerApproval || '').trim();
      if (fromDetail) return fromDetail;
      const primary = this.detailContext?.group?.primaryAd || this.detailContext?.group?.pcAd;
      const fromPrimary = String(primary?.statusCode || primary?.StatusCode || '').trim();
      if (fromPrimary) return fromPrimary;
      const display = String(this.detailAdminDisplayStatus || '').trim();
      const displayMap = {
        pending: 'P',
        pendingManualAudit: 'PA',
        aiReviewing: 'P',
        rejected: 'R',
        live: 'A',
        pendingGoLive: 'A',
      };
      if (displayMap[display]) return displayMap[display];
      const tab = this.TabList?.[this.currentTab];
      const fromTab = String(tab?.ApprovalInfo?.statusCode || tab?.bannerApproval || '').trim();
      if (fromTab) return fromTab;
      const records = tab?.records || this.adRecordInfos || [];
      const pick = (ad) => String(ad?.statusCode || ad?.StatusCode || '').trim();
      if (records.some((ad) => pick(ad) === 'R')) return 'R';
      if (records.some((ad) => pick(ad) === 'PA')) return 'PA';
      const first = records.find((ad) => pick(ad));
      return first ? pick(first) : '';
    },
    getApprovalContentResultDraft(result) {
      const id = result?.approvalRequestResultId;
      if (!id) return '';
      if (Object.prototype.hasOwnProperty.call(this.approvalContentResultDrafts, id)) {
        return this.approvalContentResultDrafts[id] || '';
      }
      return result.rejectReason || '';
    },
    setApprovalContentResultDraft(result, value) {
      const id = result?.approvalRequestResultId;
      if (!id) return;
      this.$set(this.approvalContentResultDrafts, id, value || '');
      if (String(value || '').trim()) {
        this.clearFieldRejectError(result);
      }
    },
    setApprovalContentResultCode(result, value) {
      if (!result) return;
      const code = value == null ? '' : String(value);
      this.$set(result, 'resultCode', code);
      const matched = this.approvalContentResults.find(
        (row) => row.approvalRequestResultId === result.approvalRequestResultId
      );
      if (matched && matched !== result) {
        this.$set(matched, 'resultCode', code);
      }
      if (!isProductApprovalResultRadioSelected(code)) {
        this.setApprovalContentResultDraft(result, '');
        this.clearFieldRejectError(result);
      }
    },
    getFieldRejectErrorMessage(result) {
      const id = result?.approvalRequestResultId;
      if (!id) return '';
      return this.fieldRejectErrorByKey[id] || '';
    },
    clearFieldRejectError(result) {
      const id = result?.approvalRequestResultId;
      if (!id || !this.fieldRejectErrorByKey[id]) return;
      this.$delete(this.fieldRejectErrorByKey, id);
    },
    clearAllFieldRejectErrors() {
      this.fieldRejectErrorByKey = {};
    },
    canSaveApprovalContentResult(result) {
      if (!this.fromAdmin) return false;
      const id = result?.approvalRequestResultId;
      if (!id) return false;
      const draft = this.getApprovalContentResultDraft(result);
      const reasonChanged = draft !== (result.rejectReason || '');
      const codeChanged = String(result.resultCode ?? '') !== String(result._savedResultCode ?? result.resultCode ?? '');
      return reasonChanged || codeChanged;
    },
    isSavingApprovalContentResult(result) {
      return this.savingApprovalContentResultId === result?.approvalRequestResultId;
    },
    async saveApprovalContentResult(result) {
      if (!this.fromAdmin || this.isSavingApprovalContentResult(result)) return;
      const id = result.approvalRequestResultId;
      const draft = isProductApprovalResultRadioSelected(result.resultCode)
        ? this.getApprovalContentResultDraft(result)
        : '';
      const resultCode = resolveProductApprovalResultCodeForSave(result.resultCode);
      this.savingApprovalContentResultId = id;
      try {
        const res = await adService.UpdateAdRejectReason(this.companyid, id, draft, this.langid, resultCode);
        if (!res?.isSuccessful) {
          this.$Alert(0, this.$t('lbl_EMPBE_Save_Failed_HasErrorAndCode', {
            code: res?.statusCode || '',
            msg: (res?.systemErrorMsg || []).join(','),
          }));
          return;
        }
        result.rejectReason = draft;
        result.resultCode = resultCode;
        result._savedResultCode = resultCode;
        const matched = this.approvalContentResults.find((row) => row.approvalRequestResultId === id);
        if (matched) {
          matched.rejectReason = draft;
          matched.resultCode = resultCode;
          matched._savedResultCode = resultCode;
        }
        this.$set(this.approvalContentResultDrafts, id, draft);
        this.$swal({ text: this.$t('lbl_EMPBE_SaveSuccess'), showCancelButton: false });
      } finally {
        this.savingApprovalContentResultId = null;
      }
    },
    /**
     * Resolve ApprovalId for GetRejectTemplatesByApprovalId (same sources as list/detail).
     * Prefer approval content results, then detail primary ad, then record infos.
     */
    resolveLoadedApprovalId() {
      const fromResults = (this.approvalContentResults || [])
        .map((row) => Number(row?.approvalId) || 0)
        .find((id) => id > 0);
      if (fromResults) return fromResults;

      const primary = this.detailContext?.group?.primaryAd
        || this.detailContext?.group?.pcAd
        || null;
      const fromPrimary = Number(primary?.approvalId ?? primary?.ApprovalId) || 0;
      if (fromPrimary > 0) return fromPrimary;

      const records = this.detailContext?.tab?.records || this.adRecordInfos || [];
      for (let i = 0; i < records.length; i += 1) {
        const id = Number(records[i]?.approvalId ?? records[i]?.ApprovalId) || 0;
        if (id > 0) return id;
      }
      return 0;
    },
    async loadOverallRejectTemplates() {
      const approvalId = this.resolveLoadedApprovalId();
      const cacheKey = approvalId > 0 ? approvalId : 0;
      if (
        this.overallRejectTemplates.length
        && this.overallRejectTemplatesApprovalId === cacheKey
      ) {
        return;
      }
      try {
        if (approvalId > 0) {
          const res = await adminService.GetRejectTemplatesByApprovalId(approvalId);
          if (res?.isSuccessful && res.data) {
            const raw = Array.isArray(res.data) ? res.data : [];
            const mapped = this.mapApprovalRejectTemplatesToFrf(raw);
            if (mapped.length) {
              this.overallRejectTemplates = mapped;
              this.overallRejectTemplatesApprovalId = cacheKey;
              return;
            }
          }
        }
        // No approvalId / empty / error → fall back to global reject reasons ({ id, label })
        this.overallRejectTemplates = await this.loadRejectReasonsAsFrfTemplates();
        this.overallRejectTemplatesApprovalId = cacheKey;
      } catch (e) {
        // 模板可选，失败时仅隐藏 Template 下拉
        console.error('loadOverallRejectTemplates', e);
      }
    },
    mapApprovalRejectTemplatesToFrf(raw) {
      return (Array.isArray(raw) ? raw : [])
        .map((item, idx) => {
          if (!item || typeof item !== 'object') return null;
          const title = String(item.Title ?? item.title ?? '').trim();
          const content = String(item.Content ?? item.content ?? '').trim();
          if (!title || !content) return null;
          const orderId = Number(item.OrderId ?? item.orderId);
          const hasOrder = Number.isFinite(orderId);
          return {
            id: hasOrder ? orderId : `tpl_${idx}`,
            title,
            content,
            _order: hasOrder ? orderId : idx,
          };
        })
        .filter(Boolean)
        .sort((a, b) => a._order - b._order)
        .map(({ id, title, content }) => ({ id, title, content }));
    },
    async loadRejectReasonsAsFrfTemplates() {
      const res = await adminService.GetRejectReasons();
      if (!res?.isSuccessful || !res.data) return [];
      const raw = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data.reasons)
          ? res.data.reasons
          : Array.isArray(res.data.rejectReasons)
            ? res.data.rejectReasons
            : [];
      // FieldRejectionFeedback legacy shape: { id, label }
      return raw
        .map((item, idx) => {
          if (typeof item === 'string') {
            const label = String(item).trim();
            return label ? { id: `ad_ovr_${idx}`, label } : null;
          }
          if (!item || typeof item !== 'object') return null;
          const label = item.RejectReason || item.rejectReason
            || item.RejectTitle || item.rejectTitle
            || item.reason || item.Reason || '';
          if (!String(label).trim()) return null;
          return { id: `ad_ovr_${idx}`, label: String(label).trim() };
        })
        .filter(Boolean);
    },
    /** 当前登录人展示名（待审编辑态兜底） */
    resolveCurrentOperatorName() {
      const user = this.$store?.state?.authentication?.user || {};
      return (
        user.accountName
        || user.userName
        || user.loginName
        || user.displayName
        || user.personName
        || user.PersonNameSc
        || ''
      );
    },
    /**
     * 操作人：优先详情 RejectByName / RejectBy（驳回落库后），否则当前登录人。
     * 不再写死 Admin。
     */
    hydrateApprovalRejectBy(records) {
      const list = Array.isArray(records) ? records : (this.adRecordInfos || []);
      let fromDb = '';
      for (let i = 0; i < list.length; i += 1) {
        const by = resolveApprovalRejectByActor(list[i]);
        if (by) fromDb = by;
      }
      this.approvalRejectBy = fromDb || this.resolveCurrentOperatorName() || 'AI';
    },
    /** 已驳回时从表头 ApprovalInfo / 记录回填整单驳回原因 */
    hydrateOverallRejectReasonFromRecords() {
      const code = String(this.getCurrentApprovalStatusCode() || '').trim().toUpperCase();
      const display = String(this.detailAdminDisplayStatus || '').trim();
      const isRejected = code === 'R' || display === 'rejected';
      if (!isRejected) return;

      const fromTab = this.detailContext?.tab?.ApprovalInfo?.rejectReason || '';
      const records = this.detailContext?.tab?.records || this.adRecordInfos || [];
      const rejectedRow = records.find((r) => {
        const sc = String(r?.statusCode || r?.StatusCode || '').trim().toUpperCase();
        return sc === 'R' && (r.rejectReason || r.RejectReason);
      }) || records.find((r) => r.rejectReason || r.RejectReason);
      const fromRecord = rejectedRow?.rejectReason || rejectedRow?.RejectReason || '';
      const reason = adService.resolveAdRejectReasonText(fromTab || fromRecord || '');
      if (reason) {
        this.overallRejectReasonDraft = reason;
      }
      // 已驳回：用落库 RejectBy 刷新操作人
      this.hydrateApprovalRejectBy(records);
    },
    getOverallRejectReason() {
      return (this.overallRejectReasonDraft || '').trim();
    },
    isOverallRejectActive() {
      const panel = this.$refs.overallRejectPanel;
      if (panel && typeof panel.isRejectActive === 'function') {
        return panel.isRejectActive();
      }
      return false;
    },
    getMissingFieldRejectReasons() {
      return (this.approvalContentResults || []).filter((result) => {
        if (!isProductApprovalResultRadioSelected(result.resultCode)) return false;
        return !String(this.getApprovalContentResultDraft(result) || '').trim();
      });
    },
    getSelectedFieldRejectReasons() {
      return (this.approvalContentResults || []).filter((result) =>
        isProductApprovalResultRadioSelected(result.resultCode)
      );
    },
    async validateSelectedFieldRejectReasons() {
      const missing = this.getMissingFieldRejectReasons();
      if (!missing.length) {
        this.clearAllFieldRejectErrors();
        return true;
      }
      const msg = this.$t('lbl_EMPBE_Ad_RejectSelectedNoReason');
      const errors = {};
      missing.forEach((row) => {
        const id = row.approvalRequestResultId;
        if (id) errors[id] = msg;
      });
      this.fieldRejectErrorByKey = errors;
      await this.scrollToFieldRejectError(missing[0]?.approvalRequestResultId);
      return false;
    },
    async scrollToFieldRejectError(resultKey) {
      const key = String(resultKey || '').trim();
      if (!key) return;
      await this.$nextTick();
      await new Promise((resolve) => setTimeout(resolve, 150));
      const root = this.$el;
      if (!root || typeof root.querySelector !== 'function') return;
      const safeKey = key.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      const el = root.querySelector(`[data-approval-result-key="${safeKey}"]`);
      if (!el) return;
      if (typeof el.scrollIntoView === 'function') {
        el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      }
      const input = el.querySelector('textarea.frf__input, .frf__input');
      if (input && typeof input.focus === 'function') {
        setTimeout(() => input.focus(), 180);
      }
    },
    /**
     * @param {'A'|'R'} intent Approve / Reject 按钮意图
     * @returns {Promise<{ ok: boolean, overallReason?: string }>}
     */
    async validateAdRejectBeforeSubmit(intent) {
      let blocked = false;
      let fieldsMissing = false;
      if (intent === 'R') {
        // 点驳回：已勾选但未填原因
        if (this.showAdminAdRejectPanels && !(await this.validateSelectedFieldRejectReasons())) {
          blocked = true;
          fieldsMissing = true;
        }
        if (this.showAdminOverallRejectPanel) {
          if (!this.isOverallRejectActive()) {
            const panel = this.$refs.overallRejectPanel;
            if (panel && typeof panel.ensureActive === 'function') panel.ensureActive();
          }
          const overall = this.getOverallRejectReason();
          if (!overall) {
            const panel = this.$refs.overallRejectPanel;
            const msg = this.$t('lbl_EMPBE_Ad_RejectSelectedNoReason');
            if (panel && typeof panel.showReasonError === 'function') {
              panel.showReasonError(msg, { scroll: !fieldsMissing });
            } else if (!fieldsMissing && panel && typeof panel.focusReason === 'function') {
              panel.focusReason();
            }
            blocked = true;
          }
        }
      } else if (intent === 'A') {
        const selectedFields = this.getSelectedFieldRejectReasons();
        const missingFields = this.getMissingFieldRejectReasons();
        const hasOverall = this.isOverallRejectActive() || !!this.getOverallRejectReason();
        if (hasOverall || selectedFields.length) {
          const emptyMsg = this.$t('lbl_EMPBE_Ad_RejectSelectedNoReason');
          const filledMsg = this.$t('lbl_EMPBE_Ad_ApproveWithRejectReason');
          const hasFilledOverall = !!this.getOverallRejectReason();
          const hasFilledField = selectedFields.length > missingFields.length;
          const panelMsg = (hasFilledOverall || hasFilledField) ? filledMsg : emptyMsg;
          const panel = this.$refs.overallRejectPanel;
          if (panel && typeof panel.ensureActive === 'function') panel.ensureActive();
          if (panel && typeof panel.showReasonError === 'function') {
            panel.showReasonError(panelMsg, { scroll: true });
          }
          if (selectedFields.length) {
            const missingIds = new Set(
              missingFields.map((row) => row.approvalRequestResultId).filter(Boolean)
            );
            const errors = {};
            selectedFields.forEach((row) => {
              const id = row.approvalRequestResultId;
              if (id) errors[id] = missingIds.has(id) ? emptyMsg : filledMsg;
            });
            this.fieldRejectErrorByKey = errors;
          }
          blocked = true;
        } else {
          this.clearAllFieldRejectErrors();
        }
      }
      if (blocked) return { ok: false };
      return { ok: true, overallReason: this.getOverallRejectReason() };
    },
    async saveAllAdRejectContent({ silent = true } = {}) {
      if (!this.fromAdmin) return true;
      const rows = this.approvalContentResults || [];
      for (const result of rows) {
        const id = Number(result.approvalRequestResultId) || 0;
        if (id <= 0) continue;
        const selected = isProductApprovalResultRadioSelected(result.resultCode);
        const draft = selected ? (this.getApprovalContentResultDraft(result) || '') : '';
        const resultCode = resolveProductApprovalResultCodeForSave(result.resultCode);
        const prevReason = result.rejectReason || '';
        const prevCode = String(result._savedResultCode ?? result.resultCode ?? '');
        if (draft === prevReason && resultCode === prevCode) continue;
        const res = await adService.UpdateAdRejectReason(this.companyid, id, draft, this.langid, resultCode);
        if (!res?.isSuccessful) {
          if (!silent) {
            this.$Alert(0, this.$t('lbl_EMPBE_Save_Failed_HasErrorAndCode', {
              code: res?.statusCode || '',
              msg: (res?.systemErrorMsg || []).join(','),
            }));
          }
          return false;
        }
        result.rejectReason = draft;
        result.resultCode = resultCode;
        result._savedResultCode = resultCode;
        this.$set(this.approvalContentResultDrafts, id, draft);
      }
      return true;
    },
    /**
     * 供 footer 调用：校验 + 批量保存字段驳回；不调用 AdApprove
     * @param {'A'|'R'} intent
     */
    async prepareAdApproval(intent) {
      if (!this.fromAdmin) return { ok: false };
      const validated = await this.validateAdRejectBeforeSubmit(intent);
      if (!validated.ok) return { ok: false };
      if (this.showAdminAdRejectPanels) {
        const saved = await this.saveAllAdRejectContent({ silent: false });
        if (!saved) return { ok: false };
      }
      return { ok: true, overallReason: validated.overallReason || '' };
    },
    updateUploadMedia(ad, commands, pendingFiles, imageBtns) {
      // 对齐 banner handlerUploaderUpdateData：只记变更，不回写 uploadedFiles
      // MediaArray 绑的是 uploadedFiles 稳定引用，组件内部自己留图
      const stateKey = this.getUploadStateKey(ad);
      if (!stateKey) return;
      this.$set(this.dbUpdateCommands, stateKey, [...(commands || [])]);
      this.$set(this.pendingUploadFiles, stateKey, [...(pendingFiles || [])]);
      this.$set(this.imageBtnFiles, stateKey, [...(imageBtns || [])]);
      this.markDirty();
    },
    GetHotAdIds() {
      return adService.GetAdhotAppIds().then(res => {
        if (res.data?.hotAppIds) {
          this.HotAppIds = res.data.hotAppIds.split(',');
        }
        return res;
      });
    },
    GetSearchAdOptions() {
      return adService
        .GetSearchAdOptions({ companyId: this.companyid, langId: this.langid })
        .then((res) => {
          if (res.isSuccessful) {
            this.AllAdOptionsData = res.data;
          }
          return res;
        });
    },
    GetProductCatList() {
      return CompanyInfoService.GetProductCatList().then((response) => {
        this.prodCats = response.data;
        return response;
      });
    },
    UpdateApprovalInfo(index, Info) {
      if (this.TabList[index]) {
        this.TabList[index].ApprovalInfo = Info;
      }
    },
    async CheckAdSaveAndSubmitApi(updateAdListParam, AdBySearchRecordsParam, formIds) {
      this.HasErrorData = [];
      return adService
        .CheckAdSaveAndSubmitApi(
          this.companyid,
          formIds,
          updateAdListParam ?? null,
          AdBySearchRecordsParam ?? null,
          this.$route.query.istest === 'true'
        )
        .then((res) => {
          if (res.isSuccessful) {
            this.HasErrorData = res.data ?? [];
          }
        });
    },
    ChangeHasErrorData() {
      const errorMap = new Map((this.HasErrorData || []).map((e) => [e.adBySearchId, e]));
      this.adBySearchRecords = (this.adBySearchRecords || []).map((f) => ({
        ...f,
        uPError: errorMap.get(f.rid) || null,
      }));
    },
    ChangeErrorSubmitStrus(strus) {
      this.SelectCustomErrorStrus = strus;
    },
    ChangeSubmitStrus() {
      this.SubmitStrus = false;
    },
    AdetailTips(msg, action = 'submit') {
      const addetailidList = msg.includes('addetailId') ? msg.split('|')[1] : '';
      const addetailIdLi = addetailidList.split(',').filter(Boolean);
      const tab = this.detailContext?.tab;
      const pageName = tab ? this.$t(PAGE_TYPE_I18N[tab.type] || tab.type) : '';
      let htmlLi = '';
      addetailIdLi.forEach((item) => {
        htmlLi += this.$t('lbl_EMPBE_advertisingInfo_RefreshTips_Li', { addetailId: item, pageName });
      });

      const isEn = (this.$i18n && this.$i18n.locale === 'en');
      const isSave = String(action).toLowerCase() === 'save';
      const actionTitle = isEn ? (isSave ? 'Save' : 'Resubmission') : (isSave ? this.$t('lbl_EMPBE_Save') : this.$t('lbl_EMPBE_Submit'));
      const actionVerb = isEn
        ? (isSave ? 'save the advertisements again' : 'resubmit the advertisements')
        : (isSave ? this.$t('lbl_EMPBE_Save') : this.$t('lbl_EMPBE_Submit'));

      this.showConfirm_Img(
        '',
        this.$t('lbl_EMPBE_advertisingInfo_RefreshTips', { liData: htmlLi, actionTitle, actionVerb }),
        this.$t('lbl_confirm'),
        '',
        '',
        '',
        50,
        50,
        'AlertDialog-Ad-SaveSucess',
        true,
        '',
        '',
        '',
        false,
        false,
        true,
        false
      );
    },
    getGroupRecords(group) {
      const seen = new Set();
      const list = [];
      [group.primaryAd, group.pcAd, group.mobileAd].forEach((ad) => {
        if (ad && !seen.has(ad.adDetailId)) {
          seen.add(ad.adDetailId);
          list.push(ad);
        }
      });
      return list;
    },
    /** 详情页 Save/Submit 仅允许当前 detail 组内的 AdDetailId */
    getDetailScopedRecords(records) {
      const list = records || [];
      if (!this.detailLayout) return list;
      const ctx = this.detailContext;
      if (!ctx?.group) return [];
      const allowed = new Set(
        this.getGroupRecords(ctx.group).map((r) => Number(r.adDetailId)).filter((id) => id > 0)
      );
      return list.filter((r) => allowed.has(Number(r.adDetailId)));
    },
    /**
     * 将去年广告图片填入当前页编辑态（不写库）；预览用。应用时由调用方再调 saveCurrentTab 持久化。
     */
    applyPriorYearData(priorDetailResult) {
      if (!priorDetailResult || !this.detailContext) return false;

      const priorRecords = priorDetailResult.adRecordInfos || [];
      const currentRecords = this.getGroupRecords(this.detailContext.group);
      if (!currentRecords.length || !priorRecords.length) return false;

      const resolvePriorRecord = (current) => {
        const matched = priorRecords.find(
          (p) => Number(p.adPackageId) === Number(current.adPackageId)
        );
        if (matched) return matched;
        if (priorRecords.length === 1 && currentRecords.length === 1) {
          return priorRecords[0];
        }
        return null;
      };

      const resolveImageSrc = (prior) => this.normalizeAdMediaUrl(
        prior.filePath
        || prior.temp_FilePath
        || prior.temp_filePath
        || ''
      );

      let applied = false;
      currentRecords.forEach((current) => {
        if (!current.isUpload) return;
        const prior = resolvePriorRecord(current);
        if (!prior) return;

        const imageSrc = resolveImageSrc(prior);
        if (!imageSrc) return;

        const stateKey = this.getUploadStateKey(current);
        const usageType = this.getUploadUsageType(current);
        this.$set(this.uploadedFiles, stateKey, [getInitImageDataObj(
          {
            imageId: current.adDetailId,
            cdnLnk: imageSrc,
          },
          {
            id: `${usageType || stateKey}-${current.adDetailId}`,
            cdnLink: imageSrc,
            orderId: 1,
            usageType,
          }
        )]);
        this.$set(this.dbUpdateCommands, stateKey, []);
        this.$set(this.pendingUploadFiles, stateKey, []);
        this.$set(this.imageBtnFiles, stateKey, []);
        applied = true;
      });

      if (!applied) return false;

      const tabIndex = this.detailContext.tabIndex;
      if (tabIndex != null && this.TabList[tabIndex]) {
        this.TabList[tabIndex].refreshToken = (this.TabList[tabIndex].refreshToken || 0) + 1;
      }

      this.dirty = true;
      this.$store.state.dirty = true;
      return true;
    },
    getActiveSaveTab() {
      const ctx = this.detailContext;
      if (!ctx) return null;
      const records = this.getDetailScopedRecords(this.getGroupRecords(ctx.group));
      if (!records.length) return null;
      return {
        ...ctx.tab,
        type: ctx.tab.type,
        formIds: adService.collectFormIdsFromRecords(records) || ctx.tab.formIds,
        records,
      };
    },
    uploadFinish(failedFilesFields) {
      const isSuccess = failedFilesFields.length === 0;
      this.uploadResult.isSuccessful = isSuccess;
      this.uploadResult.failedItems = [...this.uploadResult.failedItems, ...failedFilesFields];
      this.$submitFormMessage.FinishUploadPopup({ isSuccess });
    },
    showResultMessagePopup(isSuccess, message, isSubmit) {
      const isSuccessful = isSuccess && this.uploadResult.isSuccessful;
      const uploadFailedItems = this.uploadResult.failedItems;
      this.$submitFormMessage.ShowResultPopup({
        isSuccess: isSuccessful,
        message,
        isSubmit,
        uploadFailedItems,
      });
    },
    hideSubmitProgressPopup() {
      this.$submitFormMessage.HideMessagePopup();
      this.uploadResult = { ...defaultUploadResult };
    },
    buildUploadFailedTextMap(records) {
      const byStateKey = {};
      (records || []).forEach((ad) => {
        if (!ad?.isUpload) return;
        const stateKey = this.getUploadStateKey(ad);
        if (!stateKey) return;
        const platform = ad.isMobile ? this.$t("Mobile") : this.$t("Desktop");
        byStateKey[stateKey] = `${this.$t(getSubTypeMeta(ad.subType).titleKey)} - ${platform} - ${this.$t("lbl_EMPBE_Photos")}`;
      });
      return (usageType) => {
        const matched = (records || []).find((ad) => this.getUploadUsageType(ad) === usageType);
        if (matched) {
          const label = byStateKey[this.getUploadStateKey(matched)];
          if (label) return label;
        }
        return usageType;
      };
    },
    async fileUploadHandleForRecords(records, isSubmit = false) {
      const uploadRecords = (records || []).filter((ad) => ad?.isUpload);
      // 无图片上传类广告（Logo / 选产品 / 视频等）不走上传弹窗与上传队列
      if (!uploadRecords.length) {
        this.uploadResult = { ...defaultUploadResult };
        return { status: "AllSuccess", successfulList: [], failedList: [], commands: [] };
      }
      const pendingFiles = [];
      const commands = [];
      uploadRecords.forEach((ad) => {
        pendingFiles.push(...this.getCurrentPendingUploadFiles(ad));
        commands.push(...this.getCurrentUploadCommands(ad));
      });
      this.uploadResult = { ...defaultUploadResult };
      return this.$submitFormMessage.FileUploadHandleWithPopup({
        isSubmit,
        pendingFiles,
        commands,
        getFailedText: this.buildUploadFailedTextMap(uploadRecords),
        uploadFinishCallback: this.uploadFinish,
      });
    },
    async buildSaveParamsForTab(tab, options = {}) {
      const { isSubmit = false } = options;
      const scopedRecords = this.getDetailScopedRecords(tab.records);
      if (!scopedRecords.length) return null;
      const hasUploadRecords = scopedRecords.some((ad) => ad?.isUpload);
      const uploadedRes = await this.fileUploadHandleForRecords(scopedRecords, isSubmit);
      if (uploadedRes?.failedList?.length) {
        this.showResultMessagePopup(false, this.$t("lbl_EMPBE_UploadFailed"), isSubmit);
        return null;
      }

      const updateAdListParam = [];
      let blocked = false;

      for (const ad of scopedRecords) {
        const adDetailId = Number(ad.adDetailId);
        if (!adDetailId) continue;
        if (this.needProductSelect(ad)) {
          const productId = this.getRecordProductId(ad);
          if (!productId) {
            if (hasUploadRecords) this.hideSubmitProgressPopup();
            await this.$swal({ text: this.$t('Lbl_SelectSearchProduct'), showCancelButton: false });
            blocked = true;
            break;
          }
          const item = {
            adPackageId: ad.adPackageId,
            productId,
            adDetailId: ad.adDetailId,
            type: 'product',
          };
          if (ad.Keyword) item.Keyword = ad.Keyword;
          updateAdListParam.push(item);
        } else if (tab.type === 'logoAd') {
          updateAdListParam.push({
            adPackageId: ad.adPackageId,
            type: '',
            adDetailId: ad.adDetailId,
          });
        } else if (ad.isUpload) {
          const pendingForAd = this.getCurrentPendingUploadFiles(ad);
          const commandsForAd = this.getCurrentUploadCommands(ad);
          const pendingIds = new Set(pendingForAd.map((p) => p.id).filter(Boolean));
          const uploadedItem = pendingIds.size > 0
            ? (uploadedRes?.successfulList || []).find((u) => pendingIds.has(u.id))
            : null;
          const hasDeleteCommand = commandsForAd.some((item) => item.command === 'DELETE');
          const existingCdnLnk = this.getReuseCdnLnk(ad);
          const fallbackCdnLnk = this.getCurrentUploadedFiles(ad)[0]?.cdnLink || '';
          let cdnLnk = '';
          if (uploadedItem?.uploadedOssUrl) {
            cdnLnk = uploadedItem.uploadedOssUrl;
          } else if (hasDeleteCommand) {
            cdnLnk = '';
          } else {
            cdnLnk = existingCdnLnk || fallbackCdnLnk;
          }
          updateAdListParam.push({
            adPackageId: ad.adPackageId,
            cdnLnk,
            type: 'media',
            adDetailId: ad.adDetailId,
          });
        }
      }

      if (blocked) return null;

      const AdBySearchRecordsParam = adService.buildAdBySearchRecordsForTab(
        scopedRecords,
        this.adBySearchRecords
      );

      return { updateAdListParam, AdBySearchRecordsParam, hasUploadRecords, scopedRecords };
    },
    async buildAdDetailGroupPayload(tab, options = {}) {
      const legacy = await this.buildSaveParamsForTab(tab, options);
      if (!legacy) return null;

      return {
        empCompanyId: Number(this.companyid),
        pageType: this.detailPageType || tab.type,
        formIds: tab.formIds,
        adDetailId: Number(this.detailAdDetailId) || 0,
        pcAdDetailId: Number(this.detailPcAdDetailId) || 0,
        mobileAdDetailId: Number(this.detailMobileAdDetailId) || 0,
        items: legacy.updateAdListParam.map((x) => {
          const ad = (legacy.scopedRecords || []).find((r) => Number(r.adDetailId) === Number(x.adDetailId));
          return {
            adDetailId: Number(x.adDetailId),
            adPackageId: Number(x.adPackageId),
            contentType: x.type || '',
            cdnLnk: x.cdnLnk || '',
            productId: Number(x.productId) || 0,
            deviceType: adService.getAdMediaDeviceType(ad) || '',
          };
        }),
        searchRecords: legacy.AdBySearchRecordsParam || [],
        hasUploadRecords: !!legacy.hasUploadRecords,
      };
    },
    notifySaveOrSubmitResult(isSuccess, message, isSubmit, hasUploadRecords, silent = false) {
      if (hasUploadRecords) {
        if (silent && isSuccess) {
          this.hideSubmitProgressPopup();
          return;
        }
        this.showResultMessagePopup(isSuccess, message, isSubmit);
        return;
      }
      // 非上传类广告：不走上传进度弹窗，沿用简单提示
      if (!isSuccess) {
        if (message) {
          this.$Alert(0, message);
        } else {
          this.$swal({
            text: this.$t('lbl_EMPBE_SaveFailed'),
            showCancelButton: false,
          });
        }
        return;
      }
      if (!silent) {
        this.$swal({
          text: isSubmit ? this.$t('lbl_EMPBE_SubmitSuccess') : this.$t('lbl_EMPBE_SaveSuccess'),
          showCancelButton: false,
        });
      }
    },
    async saveCurrentTab(options = {}) {
      const { silent = false } = options;
      const tab = this.getActiveSaveTab();
      if (!tab) return false;
      if (this.SelectCustomErrorStrus) {
        await this.$swal({ text: this.$t('lbl_EMPBE_Error_Submit'), showCancelButton: false });
        return false;
      }
      const groupPayload = await this.buildAdDetailGroupPayload(tab, { isSubmit: false });
      if (!groupPayload) return false;
      const { hasUploadRecords, ...savePayload } = groupPayload;

      const checkPayload = adService.groupPayloadToLegacyCheckPayload(savePayload);
      await this.CheckAdSaveAndSubmitApi(checkPayload.updateAdListParam, checkPayload.AdBySearchRecordsParam, tab.formIds);
      this.ChangeHasErrorData();

      LogService.LogFormDataWithObj({
        FormId: this.companyid,
        Action: 'Before_Save',
        FormType: tab.type,
        ErrorLog: this.HasErrorData?.length ? 'RefreshCompanted' : null,
      }, savePayload);

      if (this.HasErrorData?.length) {
        const ids = [...new Set(this.HasErrorData.map((item) => item?.adetailId ?? item?.adDetailId).filter((v) => v != null))].join(',');
        await this.RefreshCompantedFunc();
        if (hasUploadRecords) this.hideSubmitProgressPopup();
        this.AdetailTips(`addetailId|${ids}`, 'save');
        return false;
      }

      const res = await adService.SaveAdDetailGroup(savePayload);
      if (!res.isSuccessful) {
        if (res.systemErrorMsg?.includes('Upstream data expired')) {
          await this.RefreshCompantedFunc();
          if (hasUploadRecords) this.hideSubmitProgressPopup();
          this.AdetailTips(res.systemErrorMsg[0], 'save');
        } else {
          this.notifySaveOrSubmitResult(false, this.$t('lbl_EMPBE_Save_Failed_HasErrorAndCode', {
            code: res.statusCode,
            msg: (res.systemErrorMsg || []).join(','),
          }), false, hasUploadRecords);
        }
        return false;
      }

      if (hasUploadRecords) {
        this.hideSubmitProgressPopup();
      }

      if (!silent) {
        const swalRes = await this.showSaveSucess(
          this.$t('lbl_EMPBE_Save_Success'),
          this.$t('lbl_EMPBE_Ad_SaveSuccess_Body')
        );
        await this.LoadAdRecords();
        adService.refreshAdMenuBadge(this.companyid, this.$store);
        if (swalRes?.isConfirmed) {
          this.btnSubmit_Click();
        }
        return true;
      }

      await this.LoadAdRecords();
      adService.refreshAdMenuBadge(this.companyid, this.$store);
      return true;
    },
    async submitCurrentTab() {
      const tab = this.getActiveSaveTab();
      if (!tab) return;
      if (this.SelectCustomErrorStrus) {
        await this.$swal({ text: this.$t('lbl_EMPBE_Error_Submit'), showCancelButton: false });
        this.CheckVals = false;
        return;
      }
      const groupPayload = await this.buildAdDetailGroupPayload(tab, { isSubmit: true });
      if (!groupPayload) {
        this.CheckVals = false;
        return;
      }
      const { hasUploadRecords, ...submitPayload } = groupPayload;

      const haveEmpty = submitPayload.items.some(
        (x) => (x.contentType === 'media' && !x.cdnLnk) || (x.contentType === 'product' && !x.productId)
      );
      if (haveEmpty) {
        if (hasUploadRecords) {
          this.showResultMessagePopup(false, this.$t('lbl_EMPBE_AdPackageRequired'), true);
        } else {
          await this.$swal({ text: this.$t('lbl_EMPBE_AdPackageRequired'), showCancelButton: false });
        }
        this.CheckVals = false;
        return;
      }

      const checkPayload = adService.groupPayloadToLegacyCheckPayload(submitPayload);
      await this.CheckAdSaveAndSubmitApi(checkPayload.updateAdListParam, checkPayload.AdBySearchRecordsParam, tab.formIds);
      this.ChangeHasErrorData();

      LogService.LogFormDataWithObj({
        FormId: this.companyid,
        Action: 'Before_Submit',
        FormType: tab.type,
        ErrorLog: this.HasErrorData?.length ? 'RefreshCompanted' : null,
      }, submitPayload);

      if (this.HasErrorData?.length) {
        const ids = [...new Set(this.HasErrorData.map((item) => item?.adetailId ?? item?.adDetailId).filter((v) => v != null))].join(',');
        await this.RefreshCompantedFunc();
        if (hasUploadRecords) this.hideSubmitProgressPopup();
        this.AdetailTips(`addetailId|${ids}`, 'submit');
        this.CheckVals = false;
        return;
      }

      const res = await adService.SubmitAdDetailGroup(
        submitPayload,
        this.$route.query.istest === 'true'
      );
      if (!res.isSuccessful) {
        if (res.systemErrorMsg?.includes('Upstream data expired')) {
          await this.RefreshCompantedFunc();
          if (hasUploadRecords) this.hideSubmitProgressPopup();
          this.AdetailTips(res.systemErrorMsg[0], 'submit');
        } else {
          this.notifySaveOrSubmitResult(false, this.$t('lbl_EMPBE_Save_Failed_HasErrorAndCode', {
            code: res.statusCode,
            msg: (res.systemErrorMsg || []).join(','),
          }), true, hasUploadRecords);
        }
        this.CheckVals = false;
        return;
      }

      if (hasUploadRecords) {
        this.hideSubmitProgressPopup();
      }
      await this.showOnlyOkShow(
        this.$t('lbl_EMPBE_Ad_SubmitSuccess_Title'),
        this.$t('lbl_EMPBE_Ad_SubmitSuccess_Body'),
        this.$t('lbl_confirm')
      );
      await this.LoadAdRecords();
      adService.refreshAdMenuBadge(this.companyid, this.$store);
      this.CheckVals = false;
    },
    async btnSave_Click() {
      await this.saveCurrentTab();
    },
    btnSubmit_Click() {
      this.SubmitStrus = true;
      this.CheckVals = false;
      this.$nextTick(() => {
        this.CheckVals = true;
        this.$nextTick(async () => {
          if (!this.SubmitStrus) {
            await this.$swal({ text: this.$t('lbl_EMPBE_Required_In_Submit'), showCancelButton: false });
            this.SubmitStrus = true;
            this.CheckVals = false;
            return;
          }
          await this.submitCurrentTab();
        });
      });
    },
    GetAdsDisplayOption() {
      var parms = {
        LangId: this.langid,
        CompanyId: this.companyid,
      };
      productService.GetIndustryByCompanyId(parms).then((response) => {
        if (response.isSuccessful) {
          var dataList = response.data;
          this.AdsDisplayOption.App = dataList.map(x => ({ value: x.id, text: x.label }));
        }
      });
      productService.GetProductCatByCompanyId(parms).then((response) => {
        if (response.isSuccessful) {
          var dataList = response.data;
          this.AdsDisplayOption.Cat = dataList.map(x => ({ value: x.id, text: x.label }));
        }
      });

      var parms2 = {
        LangId: this.langid,
      };
      productService.GetAdSearchKeyword(parms2).then((res) => {
        if (res.isSuccessful) {
          this.options = [];
          for (let index = 0; index < res.data.length; index++) {
            var item = {
              value: res.data[index].searchId,
              text: res.data[index].text,
            };
            this.AdsDisplayOption.Keyword_Options.push(item);
          }
        }
      });
    },
    async SubmitAdsDisplayChange(CurrentRID, CurAdsSearchByObj, CurAdsSearchByType) {
      var inputParam = {
        RID: CurrentRID,
        AdsSearchByObj: CurAdsSearchByObj,
        CompanyId: this.companyid,
        AdsSearchByType: CurAdsSearchByType
      }

      try {
        const res = await productService.UpdateAdsDisplay(inputParam);
        return res.isSuccessful;
      } catch (error) {
        console.error(error);
        throw error;
      }
    }
  },
  provide() {
    return {
      SubmitAdsDisplayChange: this.SubmitAdsDisplayChange,
      adGroupHost: this,
    };
  }
};
</script>
<style lang="scss" scoped>
h5 {
  font-weight: bold;
}

.tabbed .nav {
  position: absolute;
  left: 22px;
  top: 33px;
  border-bottom: none;
}

.R-StatusCode-Box {
  padding: 16px;
  background: #FFE6E6;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;

  .R-StatusCode-Title {
    color: rgba(0, 0, 0, 0.80);
    font-size: 16px;
    font-weight: 700;
    line-height: 20.80px;
    word-wrap: break-word;
    display: flex;
    gap: 8px;
    align-items: center;

    i {
      color: #CD1515;
    }
  }

  .R-StatusCode-Desc {
    color: rgba(0, 0, 0, 0.80);
    font-size: 14px;
    font-weight: 400;
    line-height: 18.20px;
    word-wrap: break-word;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    align-self: stretch;
    -webkit-box-pack: justify;
    justify-content: space-between;
  }

}

.nav-pills .nav-link {
  font-size: 16px;
}

.adTabs {
  padding-right: 300px;
  display: flex;
  min-height: 65px;
  align-items: flex-end;
}

.adTabs>li {
  margin-top: 5px;
}

.op01 {
  opacity: 0.1;
}


.AdsMainTab>a {
  font-family: Roboto;
  font-size: 36px;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: 0em;
  text-align: left;
  padding: 0px 30px 0px 30px;
  color: black;
  cursor: pointer;

  &:not(:first-child) {
    border-left: 1px solid #CDCDCD
  }

  &:hover {
    color: black
  }
}

.AddAdsItem {
  margin-left: auto;
  height: 80%;
  margin-right: 40px;
  margin-top: auto;
  margin-bottom: auto;
}

.TabTextStyles {
  color: #00000040 !important;
}

.container-fluid {
  margin-bottom: 15px;
}

.CurrentApprovalInfoMsg {
  display: flex;
  gap: 6px;
  align-items: center;
}

.TabExtraMetaBox {
  min-height: 72px;
  text-align: right;
  white-space: nowrap;
}

.TabExtraMetaBox-placeholder {
  visibility: hidden;
}

.TabExtraAddAdsBtnContainer {
  --tab-extra-separator-height: 41px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.TabExtraAddAdsBtnContainer_l {
  background-color: rgba(0, 0, 0, 0.10);
  width: 2px;
  height: var(--tab-extra-separator-height);
}

.TabExtraAddAdsBtn.btn.btn-light {
  white-space: nowrap;
  min-height: 36px;
  height: 36px;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  border: none !important;
  background: transparent !important;
  color:  rgba(0, 0, 0, 0.8)  !important;
  font-size: 16px;
  font-weight: 400;
  line-height: 16px;
  word-wrap: break-word;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  box-shadow: none !important;
  vertical-align: middle;
  margin-bottom: 6px;
}

.TabExtraAddAdsBtn.btn.btn-light i {
  color:  rgba(0, 0, 0, 0.8)  !important;
  font-size: 12px;
  line-height: 1;
  margin: 0;
}

.TabExtraAddAdsBtn.btn.btn-light:hover,
.TabExtraAddAdsBtn.btn.btn-light:focus,
.TabExtraAddAdsBtn.btn.btn-light:active {
  background: rgba(0, 0, 0, 0.05) !important;
  color: #1D2939 !important;
  box-shadow: none !important;
}
.TabExtraAddAdsBtn_active.btn.btn-light {
  background: rgba(0, 0, 0, 0.05) !important;
  color: #1D2939 !important;
  box-shadow: none !important;
}

.TabExtraAddAdsBtn.btn.btn-light:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}

.ad-loading-state {
  min-height: 360px;
  border: 1px solid #ececf2;
  border-radius: 16px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.TitleImg {
  width: 12px;
  height: 12px;
}

.AdlogoTop-Msg {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.AdlogoTop {
  display: flex;
  gap: 16px;
  padding: 12px;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 16px;
}

.logoImg {
  flex-shrink: 0;
  width: 96px;
  height: 96px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
}

.Ad-logoImg {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  border-radius: 50%;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
